import { render, staticRenderFns } from "./TrainingMaterial.vue?vue&type=template&id=92b52d36&scoped=true"
import script from "./TrainingMaterial.vue?vue&type=script&lang=js"
export * from "./TrainingMaterial.vue?vue&type=script&lang=js"
import style0 from "./TrainingMaterial.vue?vue&type=style&index=0&id=92b52d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b52d36",
  null
  
)

export default component.exports